import { createContext, useContext } from 'react';
var ItemAddedModalComponentsContext = /*#__PURE__*/createContext(null);
export var ItemAddedModalProvider = ItemAddedModalComponentsContext.Provider;
export var useItemAddedModalComponents = function useItemAddedModalComponents() {
  var context = useContext(ItemAddedModalComponentsContext);
  if (!context) {
    throw new Error("useItemAddedModalComponents must be used within ItemAddedModalProvider");
  }
  return context;
};